import { MessageCircle, FileText, Smartphone, CheckCircle2 } from "lucide-react";
import { SITE, waLink } from "../data/site";
import { Overline, SectionTitle, Accent, Reveal } from "./Reveal";

const STEPS = [
  {
    n: "1", icon: MessageCircle, title: "Fale com a gente no WhatsApp",
    text: "Informe seu nome, a cidade e o valor da conta de luz para ver se atendemos a sua cidade.",
  },
  {
    n: "2", icon: FileText, title: "Envie documento e conta",
    text: "Anexe seu RG ou CNH e a conta de luz. Os dados são lidos automaticamente.",
  },
  {
    n: "3", icon: Smartphone, title: "Assine pelo celular",
    text: "Confirme com o código que chega no seu WhatsApp e uma selfie. Pronto.",
  },
];

const DOCS = [
  "RG ou CNH, com frente e verso (de preferência em PDF)",
  "A conta de luz dos últimos 3 meses, inteira e legível (o PDF do app da distribuidora é o ideal)",
  "Seu e-mail e o seu WhatsApp, digitados com cuidado",
];

export const Connect = () => (
  <section id="conectar" className="relative py-24 sm:py-32 bg-[#04120E]" data-testid="connect-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14">
      <div>
        <Reveal>
          <Overline>Conexão grátis</Overline>
          <SectionTitle>
            Faça sua conexão <Accent>em 5 minutos</Accent>.
          </SectionTitle>
          <p className="mt-4 max-w-lg text-sm sm:text-base text-emerald-100/55 leading-relaxed">
            É gratuito e 100% pelo celular. Você continua recebendo a energia pela mesma rede: só a conta fica menor.
          </p>
        </Reveal>
        <div className="mt-12 space-y-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12}>
              <div className="flex gap-5 items-start group" data-testid={`connect-step-${s.n}`}>
                <span className="shrink-0 grid place-items-center w-12 h-12 rounded-full bg-[#00E676] text-[#04120E] font-heading font-extrabold text-lg shadow-[0_0_18px_rgba(0,230,118,0.4)] transition-transform duration-300 group-hover:scale-110">
                  {s.n}
                </span>
                <div className="pt-1">
                  <h3 className="font-heading text-lg font-bold text-white inline-flex items-center gap-2">
                    {s.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-emerald-100/55 leading-relaxed max-w-md">{s.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal delay={0.15}>
        <div className="rounded-3xl border border-[#00E676]/20 bg-[#0B261E]/70 backdrop-blur-md p-8 sm:p-10 h-fit lg:sticky lg:top-24" data-testid="connect-checklist-card">
          <h3 className="font-heading text-xl font-bold text-white">Tenha em mãos</h3>
          <ul className="mt-6 space-y-4">
            {DOCS.map((d) => (
              <li key={d} className="flex gap-3 items-start text-sm text-emerald-100/70 leading-relaxed">
                <CheckCircle2 size={17} className="shrink-0 text-[#00E676] mt-0.5" /> {d}
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-emerald-100/45 leading-relaxed border-t border-white/10 pt-5">
            Fatura borrada, desatualizada ou documento sem o verso fazem o cadastro voltar. Com os arquivos certos, a
            aprovação costuma sair em minutos.
          </p>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="connect-open-cta"
            className="mt-7 flex justify-center items-center gap-2 rounded-full bg-[#00E676] hover:bg-[#00C853] text-[#04120E] font-bold px-7 py-4 shadow-[0_0_24px_rgba(0,230,118,0.4)] transition-[background-color,transform] duration-300 hover:scale-[1.02]"
          >
            Abrir meu cadastro grátis
          </a>
          <p className="mt-5 text-[11px] text-emerald-100/40 leading-relaxed text-center">
            O cadastro é feito no sistema oficial da iGreen Energy, vinculado ao nosso time: {SITE.licenciado} ·{" "}
            {SITE.grupo} · Licenciados Autorizados iGreen Energy (ID {SITE.licenciadoId}).
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
